module.exports = __webpack_public_path__ + "img/IMG_9033_L.63b26b24.webp";